"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var react_color_1 = require("react-color");
var common_1 = require("react-color/lib/components/common");
var SliderHandle_1 = __importDefault(require("./SliderHandle/SliderHandle"));
var Swatches_1 = __importDefault(require("./Swatches/Swatches"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var HexInput_1 = __importDefault(require("./HexInput/HexInput"));
var RgbInput_1 = __importDefault(require("./RgbInput/RgbInput"));
var HslInput_1 = __importDefault(require("./HslInput/HslInput"));
var localization_1 = require("@scuf/localization");
var MainColorPicker = /** @class */ (function (_super) {
    __extends(MainColorPicker, _super);
    function MainColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.convertRGBToString = function (value) {
            return "rgba(" + value.r + ", " + value.g + ", " + value.b + ", " + value.a + ")";
        };
        _this.renderAdvancedColorSelection = function () {
            var _a = _this.props, hex = _a.hex, rgb = _a.rgb, hsl = _a.hsl, onChange = _a.onChange, i18nHex = _a.i18nHex;
            var colorTypeIndex = _this.state.colorTypeIndex;
            return (React.createElement("div", { className: "advanced-wrap" },
                React.createElement("div", { className: "saturation-block" },
                    React.createElement(common_1.Saturation, __assign({}, _this.props, { onChange: onChange }))),
                React.createElement("div", { className: "current-selection-block" },
                    React.createElement("div", { className: "current-selection", style: { background: _this.convertRGBToString(rgb) } }),
                    React.createElement(common_1.Checkboard, null)),
                React.createElement("div", { className: "slider" },
                    React.createElement(common_1.Hue, __assign({}, _this.props, { pointer: SliderHandle_1.default, onChange: onChange, direction: "horizontal" }))),
                React.createElement("div", { className: "slider" },
                    React.createElement(common_1.Alpha, __assign({}, _this.props, { pointer: SliderHandle_1.default, onChange: onChange }))),
                React.createElement("div", { className: "color-input-wrap" },
                    React.createElement("div", { className: "color-type-nav-btn prev-btn", onClick: function () { return _this.changeInputType('minus'); } },
                        React.createElement(Icon_1.default, { className: "color-type-nav-icon", root: "common", name: "caret-left", size: "small" })),
                    React.createElement("div", { className: "color-type-input-wrap" },
                        colorTypeIndex === 0 && React.createElement(HexInput_1.default, { value: hex, onChange: _this.checkHexInputColor, i18nHex: i18nHex }),
                        colorTypeIndex === 1 && React.createElement(RgbInput_1.default, { value: rgb, onChange: _this.checkRgbInputColor }),
                        colorTypeIndex === 2 && React.createElement(HslInput_1.default, { value: hsl, onChange: _this.checkHslInputColor })),
                    React.createElement("div", { className: "color-type-nav-btn next-btn", onClick: function () { return _this.changeInputType('plus'); } },
                        React.createElement(Icon_1.default, { className: "color-type-nav-icon", root: "common", name: "caret-right", size: "small" })))));
        };
        _this.changeInputType = function (direction) {
            var curType = _this.state.colorTypeIndex;
            if (direction === 'plus') {
                if (curType === 2) {
                    curType = 0;
                }
                else {
                    curType++;
                }
            }
            if (direction === 'minus') {
                if (curType === 0) {
                    curType = 2;
                }
                else {
                    curType--;
                }
            }
            _this.setState({ colorTypeIndex: curType });
        };
        _this.checkHexInputColor = function (color) {
            _this.setState({ hex: color }, function () {
                return tinycolor2_1.default(color).isValid() && _this.props.onChange(color);
            });
        };
        _this.checkRgbInputColor = function (color) {
            var a = color.a, test = __rest(color, ["a"]);
            _this.setState({ rgb: color }, function () {
                return tinycolor2_1.default(test).isValid() && !Number.isNaN(color.a) && _this.props.onChange(color);
            });
        };
        _this.checkHslInputColor = function (color) {
            var a = color.a, test = __rest(color, ["a"]);
            _this.setState({ hsl: color }, function () {
                return tinycolor2_1.default(test).isValid() && !Number.isNaN(color.a) && _this.props.onChange(color);
            });
        };
        _this.toggleAdvanced = function () {
            _this.setState({ open: !_this.state.open });
        };
        var advancedDefaultOpen = props.advancedDefaultOpen;
        _this.state = {
            open: advancedDefaultOpen ? advancedDefaultOpen : false,
            colorTypeIndex: 0,
        };
        return _this;
    }
    MainColorPicker.prototype.render = function () {
        var open = this.state.open;
        var _a = this.props, hex = _a.hex, palette = _a.palette, onChange = _a.onChange, i18nAdvanced = _a.i18nAdvanced, i18nSwatches = _a.i18nSwatches;
        var icon = open ? 'caret-up' : 'caret-down';
        return (React.createElement(React.Fragment, null,
            React.createElement(Swatches_1.default, { onSelect: onChange, activeColor: hex, palette: palette, i18nSwatches: i18nSwatches }),
            React.createElement("div", { className: "advanced-toggle", onClick: this.toggleAdvanced },
                React.createElement("div", { className: "heading" }, i18nAdvanced !== null && i18nAdvanced !== void 0 ? i18nAdvanced : React.createElement(localization_1.Translation, { transKey: "Advanced" })),
                React.createElement("div", { className: "toggle-btn" },
                    React.createElement(Icon_1.default, { className: "toggle-icon", name: icon, root: "common", size: "small" }))),
            this.state.open && this.renderAdvancedColorSelection()));
    };
    return MainColorPicker;
}(react_1.Component));
exports.default = react_color_1.CustomPicker(MainColorPicker);
